import axios from 'axios'
import { config } from '../../Utils'
import { BackendTokenAPI } from '../../../../shared/api/backend'
import { Report } from '../CreateReport'

export const api = axios.create({
  baseURL: config.API_PATH,
})

export const getKenDetailsViaInput = async (params: any) => {
  console.log('params', params)
  const authHeader = await BackendTokenAPI.convertFrontTokenToBackendToken(
    params.isAdmin ? config.ADMIN_SCOPE : config.FRONTLINE_SCOPE,
    undefined,
    true,
  )

  const data = await api.post(
    '/ken',
    { type: params.type, search_term: params.search_term },
    {
      headers: {
        ...authHeader,
        'Content-Type': 'application/json',
      },
    },
  )

  console.log('input api', data)
  return { kens: data?.data || [] }
}

export const getKenDetailsViaUploadFile = async (body: any, isAdmin: boolean = false) => {
  const authHeader = await BackendTokenAPI.convertFrontTokenToBackendToken(
    isAdmin ? config.ADMIN_SCOPE : config.FRONTLINE_SCOPE,
    undefined,
    true,
  )

  const data = await api.post('/ken/upload', body, {
    headers: {
      ...authHeader,
      'Content-Type': 'application/json',
    },
  })

  console.log('upload api', data)

  return { kens: data?.data?.kenDetails || [] }
}

export const createReportSetting = async (body: any, isAdmin: boolean = false) => {
  const authHeader = await BackendTokenAPI.convertFrontTokenToBackendToken(
    isAdmin ? config.ADMIN_SCOPE : config.FRONTLINE_SCOPE,
    undefined,
    true,
  )

  const data = await api.post('/settings', body, {
    headers: {
      ...authHeader,
      'Content-Type': 'application/json',
    },
  })

  return data.data
}

export const updateReportSetting = async (id: number | string, body: any, isAdmin: boolean = false) => {
  const authHeader = await BackendTokenAPI.convertFrontTokenToBackendToken(
    isAdmin ? config.ADMIN_SCOPE : config.FRONTLINE_SCOPE,
    undefined,
    true,
  )

  const data = await api.put(`/settings/${id}`, body, {
    headers: {
      ...authHeader,
      'Content-Type': 'application/json',
    },
  })

  return data.data
}

export const createReport = async (request: Report) => {
  const authHeader = await BackendTokenAPI.convertFrontTokenToBackendToken(config.ADMIN_SCOPE, undefined, true)

  const data = await api.post('/report', request, {
    headers: {
      ...authHeader,
      'Content-Type': 'application/json',
    },
  })

  return data.data
}

export const getTempCoverUploadUrl = async (
  params: {
    reportSettingName: string
    region: string
    contentType: string
  },
  isAdmin: boolean = false,
) => {
  const authHeader = await BackendTokenAPI.convertFrontTokenToBackendToken(
    isAdmin ? config.ADMIN_SCOPE : config.FRONTLINE_SCOPE,
    undefined,
    true,
  )

  const response = await api.post(`/store`, params, {
    headers: {
      ...authHeader,
      'Content-Type': 'application/json',
    },
  })
  return response.data
}

export const getReportSettingsList = async (
  params: {
    limit?: number
    offset?: number
    search?: string
  } = {},
  isAdmin: boolean = false,
) => {
  const authHeader = await BackendTokenAPI.convertFrontTokenToBackendToken(
    isAdmin ? config.ADMIN_SCOPE : config.FRONTLINE_SCOPE,
    undefined,
    true,
  )

  const { limit = 10, offset = 0, search } = params

  const response = await api.get('/settings', {
    params: {
      name: search,
      limit,
      offset,
    },
    headers: {
      ...authHeader,
      'Content-Type': 'application/json',
    },
  })

  const responseBody = typeof response.data === 'string' ? JSON.parse(response.data) : response.data
  console.log(responseBody)

  return {
    success: responseBody.success,
    message: responseBody.message,
    items: responseBody.data?.items || [],
    limit: responseBody.data?.limit || limit,
    offset: responseBody.data?.offset || offset,
    total: responseBody.data?.totalCount || 0,
  }
}

export const getReportList = async (
  params: {
    limit?: number
    offset?: number
    status: string
    ken?: string
    page: number
  } = {
    status: 'Pending',
    page: 1,
  },
  isAdmin: boolean = false,
) => {
  const authHeader = await BackendTokenAPI.convertFrontTokenToBackendToken(
    isAdmin ? config.ADMIN_SCOPE : config.FRONTLINE_SCOPE,
    undefined,
    true,
  )

  console.log('params', params)

  if (params.page && params.page > 1) {
    params.offset = (params.page - 1) * 10
  }

  const { limit = 10, offset = 0, status, ken } = params

  const request: any = {
    status,
    limit,
    offset,
  }

  if (ken) {
    request.ken = ken
  }

  const response = await api.get('/report', {
    params: request,
    headers: {
      ...authHeader,
      'Content-Type': 'application/json',
    },
  })

  const responseBody = typeof response.data === 'string' ? JSON.parse(response.data) : response.data
  console.log(responseBody)

  return {
    success: responseBody.success,
    message: responseBody.message,
    items: responseBody.data?.items || [],
    limit: responseBody.data?.limit || limit,
    offset: responseBody.data?.offset || offset,
    total: responseBody.data?.totalCount || 0,
  }
}

export const getPreSignedUrl = async (path: string, isAdmin: boolean = false) => {
  const authHeader = await BackendTokenAPI.convertFrontTokenToBackendToken(
    isAdmin ? config.ADMIN_SCOPE : config.FRONTLINE_SCOPE,
    undefined,
    true,
  )

  const response = await api.post(
    `/report/preurl`,
    { path },
    {
      headers: {
        ...authHeader,
        'Content-Type': 'application/json',
      },
    },
  )
  return response.data
}

export const updateReportStatus = async (
  params: {
    status: string
    report_id: number
    rejection_info?: string
  },
  isAdmin: boolean = false,
) => {
  const authHeader = await BackendTokenAPI.convertFrontTokenToBackendToken(
    isAdmin ? config.ADMIN_SCOPE : config.FRONTLINE_SCOPE,
    undefined,
    true,
  )

  const req: any = {
    status: params.status,
    report_id: params.report_id,
  }
  if (params.rejection_info) {
    req.rejection_info = params.rejection_info
  }

  const response = await api.put(`/report`, req, {
    headers: {
      ...authHeader,
      'Content-Type': 'application/json',
    },
  })
  return response.data
}

export const sendMailAPI = async (
  params: {
    report_id: number
    sendEmailTo: string[]
  },
  isAdmin: boolean = false,
) => {
  const authHeader = await BackendTokenAPI.convertFrontTokenToBackendToken(
    isAdmin ? config.ADMIN_SCOPE : config.FRONTLINE_SCOPE,
    undefined,
    true,
  )

  const req: any = {
    sendEmailTo: params.sendEmailTo,
    report_id: params.report_id,
  }

  const response = await api.post(`/report/email`, req, {
    headers: {
      ...authHeader,
      'Content-Type': 'application/json',
    },
  })
  return response.data
}

export const getReportSettingKenList = async (
  params: {
    limit?: number
    offset?: number
    setting_id?: number
    functional_location_id?: number
    ken?: number
    page: number
  } = {
    page: 1,
  },
  isAdmin: boolean = false,
) => {
  const authHeader = await BackendTokenAPI.convertFrontTokenToBackendToken(
    isAdmin ? config.ADMIN_SCOPE : config.FRONTLINE_SCOPE,
    undefined,
    true,
  )

  console.log('params', params)

  if (params.page && params.page > 1) {
    params.offset = (params.page - 1) * 10 + 1
  }

  const { limit = 10, offset = 0, setting_id, functional_location_id, ken } = params

  const response = await api.get('/report/ken', {
    params: {
      limit,
      offset,
      setting_id,
      functional_location_id,
      ken,
    },
    headers: {
      ...authHeader,
      'Content-Type': 'application/json',
    },
  })

  const responseBody = typeof response.data === 'string' ? JSON.parse(response.data) : response.data
  console.log(responseBody)

  return {
    success: responseBody.success,
    items: responseBody.data?.items || [],
    total: responseBody.data?.totalCount || 0,
  }
}

export const updateKenConnectivityStatus = async (
  params: {
    report_setting_id: number
    isAllFull?: boolean
    isAllPartial?: boolean
    kens?: {
      connectivity_type: string
      ken: number
    }[]
  },
  isAdmin: boolean = false,
) => {
  const authHeader = await BackendTokenAPI.convertFrontTokenToBackendToken(
    isAdmin ? config.ADMIN_SCOPE : config.FRONTLINE_SCOPE,
    undefined,
    true,
  )

  const req: any = {
    report_setting_id: params.report_setting_id,
  }

  if (params.isAllFull) {
    req.isAllFull = params.isAllFull
  }

  if (params.isAllPartial) {
    req.isAllPartial = params.isAllPartial
  }

  if (params.kens && params.kens.length) {
    req.kens = params.kens
  }

  const response = await api.put(`/report/ken`, req, {
    headers: {
      ...authHeader,
      'Content-Type': 'application/json',
    },
  })
  return response.data
}

export const deleteReportSetting = async (id: number | string, isAdmin: boolean = false) => {
  const authHeader = await BackendTokenAPI.convertFrontTokenToBackendToken(
    isAdmin ? config.ADMIN_SCOPE : config.FRONTLINE_SCOPE,
    undefined,
    true,
  )

  const data = await api.delete(`/settings/${id}`, {
    headers: {
      ...authHeader,
    },
  })

  return data.data
}

export const getFunctionalList = async (
  params: {
    limit?: number
    offset?: number
    functional_location_name?: string
    page: number
  } = {
    page: 1,
  },
  isAdmin: boolean = false,
) => {
  const authHeader = await BackendTokenAPI.convertFrontTokenToBackendToken(
    isAdmin ? config.ADMIN_SCOPE : config.FRONTLINE_SCOPE,
    undefined,
    true,
  )

  console.log('params', params)

  if (params.page && params.page > 1) {
    params.offset = (params.page - 1) * 10 + 1
  }

  const { limit = 10, offset = 0, functional_location_name } = params

  const response = await api.get('/report/functional-location', {
    params: {
      limit,
      offset,
      functional_location_name,
    },
    headers: {
      ...authHeader,
      'Content-Type': 'application/json',
    },
  })

  const responseBody = typeof response.data === 'string' ? JSON.parse(response.data) : response.data

  return {
    success: responseBody.success,
    items: responseBody.data?.list || [],
    total: responseBody.data?.total || 0,
  }
}

export const deleteFunctionalLocationKen = async (
  params: {
    functional_location_id: number
    isAll?: boolean
    kens?: any[]
  },
  isAdmin: boolean = false,
) => {
  const authHeader = await BackendTokenAPI.convertFrontTokenToBackendToken(
    isAdmin ? config.ADMIN_SCOPE : config.FRONTLINE_SCOPE,
    undefined,
    true,
  )

  const req: any = {
    functional_location_id: params.functional_location_id,
  }

  if (params.isAll) {
    req.isAll = params.isAll
  }

  if (params.kens && params.kens.length) {
    req.kens = params.kens
  }

  const response = await api.delete(`/report/ken`, {
    data: req,
    headers: {
      ...authHeader,
      'Content-Type': 'application/json',
    },
  })
  return response.data
}
